/** CASL subjects — map to domain entities in the dispatcher UI */
export const SUBJECTS = {
  STATISTICS: 'Statistics',
  WEB_USERS: 'WebUsers',
  CONFIGURATION: 'Configuration',
  DRIVE: 'Drive',
  DRIVER: 'Driver',
  DRIVER_ACCOUNT: 'DriverAccount',
  CAR: 'Car',
  STAND: 'Stand',
  AD: 'Ad',
};
